import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.svg";
import { useLazyLoad } from "../hook/useLazyLoad.js";

import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";


// Email JS
const SERVICE_ID = process.env.REACT_APP_EMAIL_SERVICE_ID; 
const TEMPLATE_ID = process.env.REACT_APP_EMAIL_TEMPLATE_ID;
const USER_ID = process.env.REACT_APP_EMAIL_USER_ID;

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-4/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-8/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div`
  ${tw`rounded bg-contain bg-no-repeat bg-center h-full`}
`;

const LazyImage = ({ imageSrc, ...props }) => {
  const { isLoaded, containerRef } = useLazyLoad(imageSrc);

  return (
    <Image
      ref={containerRef}
      {...props}
      style={{
        backgroundImage: isLoaded ? `url(${imageSrc})` : "none",
        backgroundColor: isLoaded ? "transparent" : "#f0f0f0", // Añade un color de fondo mientras se carga la imagen
        minHeight: '200px'
      }}
    />
  );
};

const TextContent = tw.div`w-full lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;

const Form = tw.form`w-full mt-4 text-sm flex flex-col max-w-sm mx-auto md:mx-0`

const Input = tw.input`border-2 px-5 py-3 mt-4 rounded focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
const Textarea = tw.textarea`border-2 px-5 py-3 mt-4 rounded focus:outline-none font-medium transition duration-300 hocus:border-primary-500 h-full lg:h-40 resize-none`;

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-6`

export default ({
  subheading = "Contact Us",
  heading = <>Feel free to <span tw="text-primary-500">get in touch</span><wbr/> with us.</>,
  submitButtonText = "Contact us",
  formAction = "#",
  formMethod = "get",
  textOnLeft = true,
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const [ token, setToken ] = useState();

  const handleVerify = token => {
    setToken(token);
  }

  const onSubmit = e => {
    e.preventDefault();
  
    if (!token) return;
  
    // Captura los valores manualmente del formulario
    const formData = {
      from_name: e.target.name.value,
      email: e.target.email.value,
      message: e.target.message.value
    };
    console.log(formData);
  
    emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, USER_ID)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Sent Successfully"
        });
      }, (error) => {
        Swal.fire({
          icon: "error",
          title: "Ooops, something went wrong",
          text: error.text,
        });
      });
  
    e.target.reset();
  };
  

  return (
    <Container id="contact-us">
      <TwoColumn>
        <ImageColumn>
          <LazyImage imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            <Form action={formAction} onSubmit={onSubmit}>
              <Input type="text" name="name" placeholder="Your Name" minlength="3" maxlength="50" pattern="[A-Za-zÀ-ÿ\u00f1\u00d1'’.\-\s]+" required/>
              <Input type="email" name="email" placeholder="Your Email Address" required />
              <Textarea name="message" placeholder="Your Message Here" minlength="3" maxlength="500" required/>
              <SubmitButton type="submit">{submitButtonText}</SubmitButton>
              <GoogleReCaptcha onVerify={handleVerify} />
            </Form>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
